/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnEventExerciseStatus } from './en-event-exercise-status';
 /**
 *
 *
 * @export
 * @interface UpdateEventExerciseStatusDto
 */
export interface UpdateEventExerciseStatusDto {

    /**
     * What became of the exercise. Only SKIPPED is accepted today; other EnEventStatus values are rejected with a 400.
     *
     * @type {EnEventExerciseStatus}
     * @memberof UpdateEventExerciseStatusDto
     */
    status: EnEventExerciseStatus;

    /**
     * Free-form session state snapshot (e.g. exerciseSequence, lap, phase). Persisted to Redis for crash recovery, exactly as on the metrics endpoint. Max 4096 bytes when JSON-serialized.
     *
     * @type {{ [key: string]: any; }}
     * @memberof UpdateEventExerciseStatusDto
     */
    metadata?: { [key: string]: any; };
}
